import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import Truncate from "react-truncate";

import cx from 'classnames';
import _ from 'lodash';

import { fetchingInteractivePageLeadInteraction, fetchingLeadInteractionChartForInteractivePage, fetchingLandingPageLeadInteraction, fetchingLeadInteractionChartForLandingPage } from 'actions/leads';

import { TrendsPieChart } from '../../reports/components/charts'
import { EmptyMessage, LoadingMessage, PageAnalyticsHeader, PageInteractionsHeader, TableInfo } from './index';
import { TableFooter } from '../../reports/components/tableFooter';
import {DropdownFilter} from '../../reports/components/dropDown'
import { formatDurationWithLabel } from '../../reports/reporthelpers';
import { INTERACTIVE_CONTENT_TYPES } from 'constants/storyboardType';
import styles from '../leadReports.module.scss';

export function 
PageInteractions(props) {
  const dispatch = useDispatch();
  const { profileId, reportDate } = props;
  let { storyboardId } = useParams();
  const storyboardType = useSelector(state => _.get(state, 'storyboards.storyboard.item.type'));
  const PageInteractions = useSelector(state => _.get(state, 'lead.pagesInteractions.items')) || [];
  const chartData = useSelector(state => _.get(state, 'lead.pagesInteractions.chartItems'));
  const pagination = useSelector(state => _.get(state, 'lead.pagesInteractions.pagination'));
  const loading = useSelector(state => _.get(state, 'lead.pagesInteractions.loading'));
  const [currentChart, setCurrentChart] = useState("table_view");
  const [viewOption, setViewOption] = useState({ label: 'Views', value: 'views', name: 'name' })

  useEffect(() => {
    if (reportDate) {
      handlePageChange(0);
    }
  }, [reportDate]);

  const handlePageChange = (page) => {
    handleFetchPageViewsReport(page);
  }

  const handleFetchPageViewsReport = (page) => {
    var request = {
      storyboard: storyboardId,
      ...reportDate,
    }

    if (INTERACTIVE_CONTENT_TYPES.includes(storyboardType)) {
      dispatch(fetchingInteractivePageLeadInteraction(profileId, request, page, 5));
      dispatch(fetchingLeadInteractionChartForInteractivePage(profileId, request, 0, 6));
    } else {
      dispatch(fetchingLandingPageLeadInteraction(profileId, request, page, 5));
      dispatch(fetchingLeadInteractionChartForLandingPage(profileId, request, 0, 6));
    }
  }

  const handleChartChange = (value) => {
    setCurrentChart(value)
  }

  const handleArrange = (data) => {
    setViewOption(state => {
      return {
        ...state,
        label: data.label,
        value: data.value
      }
    });
  }

  return (
    <div className={styles.pageAnalyticsWrapper}>
      <div className={styles.pageAnalyticsContainer}>
        <TableInfo
          name="Page Interactions"
          pagination={pagination} />

        {currentChart == "table_view" && <PageInteractionsHeader />}

        {currentChart == "pie_chart_view" && <DropdownFilter disableOption={['visitors']}  arrangeOption={viewOption} handleArrange={handleArrange} />}

        {currentChart == "table_view" &&
          !loading && PageInteractions && PageInteractions.map((data, index) => {
            return <PageReportView data={data} loading={loading} index={index} />
          })
        }

        {(_.size(chartData) > 0 && currentChart == "pie_chart_view") &&
          <div className={styles.graphSmallView}>
            <TrendsPieChart data={chartData} viewOption={viewOption} height={320} width="100%" />
          </div>
        }

        {loading && (PageInteractions && PageInteractions.length > 0) &&
          <LoadingMessage />
        }

        {(PageInteractions && PageInteractions.length == 0) && !loading &&
          <EmptyMessage />
        }
      </div>

      <TableFooter
        currentChart={currentChart}
        disableView={['graph_view']}
        handleChartChange={handleChartChange}
        handlePageChange={handlePageChange}
        pagination={pagination}
        leftAlign={true}
        paginationName={"Pages"}
      />
    </div>
  )

  function PageReportView({ data, index }) {
    if (!data || data.length <= 1) {
      return false;
    }

    return (
      <div key={index} className={styles.pageAnalyticsRow}>
        <div className={cx(styles.wrapper, styles.pageNameColumn)}>
          <div className={styles.headline}><Truncate width={70} lines={1}>{data.name}</Truncate></div>
        </div>

        <div className={cx(styles.wrapper, styles.viewsColumn)}>
          <div className={styles.headline}>{data.views}</div>
        </div>
        <div className={cx(styles.wrapper, styles.timespentColumn)}>
          <div className={styles.headline}>{formatDurationWithLabel(data.timeSpent).value}</div>
        </div>
        <div className={cx(styles.wrapper, styles.bounceRateColumn)}>
          <div className={styles.headline}>{`${Math.round(data.percentageCompleted)}%`}</div>
        </div>
      </div>
    )
  }
}
